import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IWithdraw {
    address: string
    amount: number
    approval_signature: string
    approved_by: string
    blockchain: string
    chain_timestamp: number
    chain_tx_id: string
    coin: string
    created_at: string
    fee: number
    id: string
    ip: string
    moved: boolean
    reason: string
    sign_string: string
    signature: string
    status: string
    updated_at: string
    user_id: string
    verified: boolean
    wallet_id: string
}

export const getWithdraw = async (status?: string, before?: number): Promise<ApiRes<IWithdraw[]>> => {
    return await apiGet(API_URL, `admin/crypto/withdraws?status=${status ? status : ''}&before=${before}`)
}
